import { Position, State } from 'src/types'
import { positionChecker } from 'src/logic'
import { outfielderDefaultBackLace } from 'src/features/dxm/drawer/rightThrow/glove/back/lace/outfielderDefaultBackLace'
import { beltBackStyleDrawer } from 'src/features/dxm/drawer/rightThrow/glove/back/backStyles/beltBackStyleDrawer'

export const backStyleOfGloveBackDrawer = (ctx: CanvasRenderingContext2D, state: State, position: Position): void => {
  const needCatchFaceWrap = !state.baseModel?.isUBack || false
  // 通常ベルトモデル
  beltBackStyleDrawer(ctx, state, needCatchFaceWrap)

  // 背面紐通し(外野手のみ)
  const { isOutfielder } = positionChecker(position)
  isOutfielder && outfielderDefaultBackLace(ctx, state.lace?.color)
}
